import React from 'react';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import { Button, Table, Alert } from 'react-bootstrap';

//Actions
import { pesquisa, novoatualiza } from '../../../../actions/traducoes/traducoes';

//Components
import { campotexto } from '../../../../components/forms/campos/campos';
import FormTraducoesSubLista from './FormTraducoesSubLista';
import FormTraducoesPesquisa from './FormTraducoesPesquisa';

//Utils
import { getEvento } from '../../../../utils/eventosession';

//Helpers
import { TelaModalLivre } from '../../../../helpers/TelaModal';

class FormTraducoes extends React.Component {

    state = {
        identificador: false
    }

    componentDidMount(){
        const evento = getEvento();
        this.props.pesquisa({
            idpromotora: evento.idpromotora, 
            idevento: evento.idevento,
            wherein: JSON.stringify({ 
                campo: 'identificador', 
                valores: ['passo1','end','novopasso1','conf_index']
            })
        });
    }

    handleSubmit = async (form) => {    
        const evento = getEvento();             
        const dados = {
            idpromotora: evento.idpromotora,
            idevento: evento.idevento,
            ...form
        }
        await this.props.novoatualiza(dados);
        await this.props.pesquisa({
            idpromotora: evento.idpromotora, 
            idevento: evento.idevento,
            wherein: JSON.stringify({ 
                campo: 'identificador', 
                valores: ['passo1','end','novopasso1','conf_index']
            })
        });        
    }

    handleEditar = (form, item) => {
        form.change('idtraducao', item.idtraducao);
        form.change('portugues', item.portugues);
        form.change('ingles', item.ingles);
        form.change('espanhol', item.espanhol);
    }

    handleIdentificador = (identificador) => {
        this.setState({
            identificador: this.state.identificador===identificador?false:identificador
        })
    }

    handleModalCadastro = (form) => {
        form.reset();
    }
            
    render() {        
        return (
            <>
            <FormTraducoesPesquisa />
            <Form
            onSubmit={this.handleSubmit}            
            validate={values => {
                const errors = {};
                if(!values.portugues){
                    errors.portugues = 'Obrigatório'
                }                
                return errors;
            }}
            render={({ submitting, pristine, form, handleSubmit, submitSucceeded }) => {
                this.formfinal = form;
                let identificadoratual = '';
                const gravou = submitSucceeded&&this.props.cadupdated&&this.props.cadupdated.idtraducao?true:false;
                return (
                    <form onSubmit={handleSubmit}>
                        <TelaModalLivre show={gravou} handleCloseModal={() => this.handleModalCadastro(form)}>
                            <Alert variant="success">Cadastro Feito com Sucesso</Alert>
                        </TelaModalLivre>               
                        <Table striped bordered hover style={{paddingBottom: '150px', marginBottom: '150px'}}>
                            <thead>
                                <tr>
                                <th>Português</th>
                                <th>Inglês</th>
                                <th>Espanhol</th>
                                <th>Editar</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.cadastros.length?this.props.cadastros.map(itens => {
                                    const lista = (                                        
                                        identificadoratual!==itens.identificador?
                                        <tr 
                                        className="bg-info text-center" 
                                            key={itens.idtraducao}
                                            style={{cursor: 'pointer'}} onClick={() => this.handleIdentificador(itens.identificador)}>
                                            <td className="text-break" colSpan="4">
                                                {itens.pagina?itens.pagina.descricao:null}
                                            </td>
                                        </tr>
                                        :
                                        null                                        
                                    )
                                    identificadoratual=itens.identificador;
                                    return lista;
                                })
                                :
                                null
                                }    
                                {this.state.identificador!==false?
                                <FormTraducoesSubLista
                                cadastros={this.props.cadastros} 
                                identificador={this.state.identificador}
                                form={form}
                                handleEditar={this.handleEditar}
                                />
                                :
                                null
                                }      
                            </tbody>
                        </Table>
                        <Table striped bordered hover className="table-dark" style={{position: 'sticky', bottom: '50px', maxWidth: "100%"}}>
                            <tbody>
                                <tr>
                                    <td>                                    
                                        <Field type="hidden" name="idtraducao" component={campotexto} />
                                        <Field type="text" label="Português" placeholder="Português" name="portugues" component={campotexto}/>
                                    </td>
                                    <td>
                                        <Field type="text" label="Inglês" placeholder="Inglês" name="ingles" component={campotexto} />
                                    </td>
                                    <td>
                                        <Field type="text" label="Espanhol" placeholder="Espanhol" name="espanhol" component={campotexto} />
                                    </td>
                                </tr>
                                <tr>
                                    <td className="text-center" colSpan="3">
                                        <Button type="submit" disabled={pristine || submitting}>Confirmar</Button>
                                    </td>
                                </tr>                                          
                            </tbody>
                        </Table>
                    </form>
                )
            }}
            />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {        
        pendingTasks: state.pendingTasks,
        cadastros: state.reducerTraducoes,
        cadupdated: state.traducoesNovaAtualizaReducer    
    }
}

export default connect(mapStateToProps, { pesquisa, novoatualiza })(FormTraducoes);